import FooterForm from './footerForm'

export default FooterForm